import { DirectionToolSidebar } from 'components/minute/sidebar/ToolSidebar/DirectionToolSidebar';
import { DrawToolSidebar } from 'components/minute/sidebar/ToolSidebar/DrawToolSidebar';
import { IconToolSidebar } from 'components/minute/sidebar/ToolSidebar/IconToolSidebar';
import { ImageToolSidebar } from 'components/minute/sidebar/ToolSidebar/ImageToolSidebar';
import { IndoorStandToolSidebar } from 'components/minute/sidebar/ToolSidebar/IndoorStandToolSidebar';
import { LineToolSidebar } from 'components/minute/sidebar/ToolSidebar/LineToolSidebar';
import { PolygonToolSidebar } from 'components/minute/sidebar/ToolSidebar/PolygonToolSidebar';
import { TextToolSidebar } from 'components/minute/sidebar/ToolSidebar/TextToolSidebar';
import { UploadToolSidebar } from 'components/minute/sidebar/ToolSidebar/UploadToolSidebar';
import { WallToolSidebar } from 'components/minute/sidebar/ToolSidebar/WallToolSidebar';
import { EWorldAction } from 'libs/utils/world/worldTypes';
import { useContext, useEffect } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const action = ctxEdit.worldAction;

    useEffect(() => {
        console.log('Action changed to: ', action);
    }, [action]);

    return (
        <S_ToolSidebar className={props.className}>
            {action === EWorldAction.ICON_V2 && <IconToolSidebar />}
            {action === EWorldAction.VARIANT_ICON_V2 && <IconToolSidebar />}
            {action === EWorldAction.IMAGE_V2 && <ImageToolSidebar />}
            {action === EWorldAction.TEXT && <TextToolSidebar />}
            {action === EWorldAction.DRAW && <DrawToolSidebar />}
            {action === EWorldAction.DIRECTION && <DirectionToolSidebar />}
            {action === EWorldAction.LINE_V2 && <LineToolSidebar />}
            {action === EWorldAction.POLYGON_V2 && <PolygonToolSidebar />}
            {action === EWorldAction.INDOOR_STAND && <IndoorStandToolSidebar />}
            {(action === EWorldAction.POLYGON_V2_WALL || action === EWorldAction.LINE_V2_WALL) && (
                <WallToolSidebar />
            )}
            {action === EWorldAction.UPLOAD && <UploadToolSidebar />}
        </S_ToolSidebar>
    );
};

const S_ToolSidebar = styled.div`
    width: 100%;
    padding: 0 0 200px 0;
`;
